"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zIndex = void 0;
var type_guard_1 = require("@webnuts/type-guard");
/** @see <https://developer.mozilla.org/en-US/docs/Web/CSS/z-index> */
exports.zIndex = type_guard_1.union([type_guard_1.literal('auto'), type_guard_1.integer()]);
